import { render, staticRenderFns } from "./InteractionOfBtnBackgroundColor.vue?vue&type=template&id=391f34a2&scoped=true&"
import script from "./InteractionOfBtnBackgroundColor.vue?vue&type=script&lang=js&"
export * from "./InteractionOfBtnBackgroundColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f34a2",
  null
  
)

export default component.exports